const letterItems = document.querySelectorAll('#letters .letter');

// remove brandChars with no brands
document.querySelectorAll('.char-item:not(:has(li))').forEach(charItem => charItem.remove())

letterItems.forEach(letterItem => {
  const letter = letterItem.innerText;
  const letterBrandsGroup = document.getElementById(letter);

  // add smooth scroll event to on a letter click
  letterItem.addEventListener('click', () => scrollSmoothlyTo(letterBrandsGroup));

  if (!letterBrandsGroup) letterItem.classList.add('disabled');
})

function scrollSmoothlyTo(target) {
  if (!target) return;

  window.scrollTo({
    top: target.offsetTop - document.querySelector('x-navbar').offsetHeight - 20,
    behavior: 'smooth',
  });
}